import { render } from "./close-button.vue?vue&type=template&id=536f168e&scoped=true"
const script = {}

import "./close-button.vue?vue&type=style&index=0&id=536f168e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-536f168e"
/* hot reload */
if (module.hot) {
  script.__hmrId = "536f168e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('536f168e', script)) {
    api.reload('536f168e', script)
  }
  
  module.hot.accept("./close-button.vue?vue&type=template&id=536f168e&scoped=true", () => {
    api.rerender('536f168e', render)
  })

}

script.__file = "resources/ts/components/elements/close-button.vue"

export default script